import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98248e9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-hidden-touch" }
const _hoisted_2 = { class: "title-four title-overflow mb-0" }
const _hoisted_3 = { class: "custom-navbar-style navbar mb-1" }
const _hoisted_4 = { class: "is-fullwidth navbar-menu" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fa-lg fas fa-binoculars is-disabled" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "is-boxed navbar-dropdown" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "is-boxed navbar-dropdown p-2"
}
const _hoisted_10 = { class: "table" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Property"),
    /*#__PURE__*/_createElementVNode("th", null, "Value")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Name", -1))
const _hoisted_13 = { class: "force-button-alignment navbar-end" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fa-lg fas fa-upload" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["accept"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fa-lg fas fa-trash" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]

import DeleteContentModal from '@/components/common/modal/DeleteContentModal.vue'
import i18n from '../../../../../../locales'
import { acceptedFileTypes, HoopsModelView, HoopsToolbarIcon } from '@/plugins/hoops'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopToolbar',
  props: {
  disabled: Boolean, // affects all buttons except upload
  hasEditOptions: Boolean, // controls visibility of properties, upload and delete option
  hasFileProcessing: Boolean, // disables upload option
  title: String
},
  emits: ['delete', 'upload'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const fileInput = ref<HTMLInputElement | null>(null)

const store = useStore()
const captureSnapshot = () => store.dispatch('hoopsWebViewer/captureSnapshot')
const changeModelView = async (modelView: HoopsModelView) => await store.dispatch('hoopsWebViewer/changeModelView', modelView)
const currentModelView = computed(() => store.getters['hoopsWebViewer/currentModelView'])
const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement

  if (target.files && target.files.length > 0) {
    emit('upload', Array.from(target.files))
  }
  target.value = ''
}
const triggerFileInput = () => {
  if (fileInput.value) {
    fileInput.value.click();
  }
}
const hoopsDeleteModal = ref(null)
const modelProperties = computed( () => store.getters['hoopsWebViewer/modelProperties'])
const modelViewOptions = computed( () => store.getters['hoopsWebViewer/modelViewOptions'])
const onDeleteModelOpen = () => hoopsDeleteModal.value!!.open()
const onDeleteModelSubmit = async () => {
  emit('delete')
  hoopsDeleteModal.value!!.close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(__props.title ?? _ctx.$t('threeD.viewerTitle')), 1),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["force-button-alignment navbar-start", { 'force-alignment': !__props.hasEditOptions }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["navbar-item normal-icon", { 'has-dropdown': modelViewOptions.value.length > 0, 'is-hoverable': modelViewOptions.value.length > 0 }])
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["is-arrowless navbar-link", { 'disabled': modelViewOptions.value.length === 0 || __props.disabled }])
            }, _hoisted_6, 2),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelViewOptions.value, (option) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(["navbar-item", { 'is-selected': currentModelView.value?.nodeId === option.nodeId }]),
                  onClick: ($event: any) => (changeModelView(option))
                }, _toDisplayString(option.label), 11, _hoisted_8))
              }), 256))
            ])
          ], 2),
          _createElementVNode("a", {
            class: _normalizeClass(["hoops-icon navbar-item", { 'custom-disabled': __props.disabled }]),
            onClick: captureSnapshot
          }, [
            _createVNode(_unref(HoopsToolbarIcon), { type: "snapshot" })
          ], 2),
          (__props.hasEditOptions)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["hoops-icon navbar-item", { 'has-dropdown': !__props.disabled, 'is-hoverable': !__props.disabled }])
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass(["is-arrowless navbar-link", { 'custom-disabled': __props.disabled }])
                }, [
                  _createVNode(_unref(HoopsToolbarIcon), { type: "settings" })
                ], 2),
                (modelProperties.value !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("table", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_12,
                            _createElementVNode("td", null, _toDisplayString(modelProperties.value.nodeName), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelProperties.value.properties, (value, key) => {
                            return (_openBlock(), _createElementBlock("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(key), 1),
                              _createElementVNode("td", null, _toDisplayString(value), 1)
                            ]))
                          }), 256))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_13, [
          (__props.hasEditOptions)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: _normalizeClass(["navbar-item normal-icon", { 'disabled': __props.hasFileProcessing }]),
                onClick: triggerFileInput
              }, _hoisted_15, 2))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            class: "is-hidden",
            multiple: "",
            ref_key: "fileInput",
            ref: fileInput,
            type: "file",
            accept: _unref(acceptedFileTypes),
            onChange: handleFileChange
          }, null, 40, _hoisted_16),
          (__props.hasEditOptions)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: _normalizeClass(["navbar-item normal-icon", { 'disabled': __props.disabled }]),
                onClick: onDeleteModelOpen
              }, _hoisted_18, 2))
            : _createCommentVNode("", true)
        ]),
        _createVNode(DeleteContentModal, {
          ref_key: "hoopsDeleteModal",
          ref: hoopsDeleteModal,
          onSubmit: onDeleteModelSubmit
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('threeD.deleteTitle')), 1)
          ]),
          _: 1
        }, 512)
      ])
    ])
  ]))
}
}

})